export default __webpack_public_path__ + "static/media/homeplussecuritysuits-blue-bg.ca7756db.png";